var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurplemail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 0H5a5 5 0 00-5 5v26a5 5 0 005 5h38a5 5 0 005-5V5a5 5 0 00-5-5zm-1.87 9.65L28 18.7a7.07 7.07 0 01-7.94 0L6.9 9.7a2 2 0 112.26-3.3l13.14 9a3 3 0 003.4 0l13.17-9a2 2 0 112.26 3.3z",
    fill: "#d3d4ed"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurplemail);
export default __webpack_public_path__ + "static/media/purplemail.c3d23a95aa15af287bfa9d924881fa6f.svg";
export { ForwardRef as ReactComponent };